import React, {useEffect, useState, useMemo} from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import { useSelector, useDispatch} from 'react-redux';
import { Divider, Loader, Modal, Button } from 'rsuite';
import * as actionsAuth from '../../../../../app/actions/auth/auth';
import * as actionsUser from '../../../../../app/actions/user';
import * as actionsPolicy from '../../../../../app/actions/policy';
import {setInstallmentText}  from '../../../../../app/common/services/vehicle.service';
import {InfoIcon} from '../../svg/iconsSvg';
import {FrameTwoIcon} from '../../svg/iconFrameTwoSvg';


const PaymentFinishedNC = () => {

   const { search } = useLocation();
  
   let query = useMemo(() => new URLSearchParams(search), [search]);

   const refreshToken = query.get("refreshToken");
   const insuranceId = query.get("insuranceId");
   const cashflowId = query.get("cashflowId");
   const status = query.get("status"); 

    const dispatch = useDispatch();
    const history = useHistory()

    const {loginToken} = useSelector(state => state.auth);

    const {myPolicies} = useSelector(state=>state.userDetails);

    const [policy, setPolicy] = useState({});

//console.log(policy);

    const cashflow = policy?.cashflows ? policy?.cashflows.find(obj => obj.cashflowId === parseInt(cashflowId) ) : {};
    let payAmount =  Number.parseFloat(cashflow?.dueAmount).toFixed(2);
    
    payAmount = Number.isNaN(parseInt(payAmount)) ? null : payAmount;

    let payAmountEUR =  Number.parseFloat(cashflow?.dueAmountEUR).toFixed(2);
    payAmountEUR = Number.isNaN(parseInt(payAmountEUR)) ? null : payAmountEUR;

    const insCompany = policy?.insCompany;
    const registered = policy?.questions?.generalRegistrationType === '1' ? true : false;
    //console.log(registered, insCompany, policy)

    const {make, model, plate} = policy?.registrationProps || {};
    const vechicleMake = make ? `${make.value} ${model?.value}` : null;
    const vechiclePlate = plate ? ` ${plate?.value}` : null;

    const [loading, setLoading]   = useState(false);

    const [showNoSuccess, setShowNoSuccess] = useState(false);

    const infoTexts = ['Плащането завърши успешно', 'Твоята полица е в процес на обработка', 'Ще получиш имейл когато полицата е готова',
                    insCompany === 'dallbogg' && !registered
                    ? 'При склюване на 1-годишна полица за нерегистрирано МПС е необходимо в 30 дневен срок да ни изпратиш талона на автомобила на help@nuins.io, за да не бъде прекратена полицата'
                    : null
                    ];
    
    useEffect( () => {
        const fetchLoginToken = async () => {
            setLoading(true);

            const res = await dispatch(actionsAuth.refreshLoginToken(refreshToken))

            if(!res?.payload) {
               return history.push('/');
            }

            setLoading(false);
        }
        if(!loginToken) {
            fetchLoginToken();
        }
    }, [loginToken, refreshToken, history, dispatch]);

    useEffect(() => {
        const fetchUserData = async () => {
            setLoading(true);
            await Promise.all([dispatch(actionsUser.getUser()), dispatch(actionsUser.getMyPolicies())]);
            await  dispatch(actionsUser.getUserAddresses());
            if(status === 'ERROR') {
                setShowNoSuccess(true)
            }
            setLoading(false);
        }
        if(loginToken) {
            fetchUserData()
        }

    }, [loginToken, dispatch, status]);

    useEffect(()=>{
        if(myPolicies && myPolicies.length){
            const policy = myPolicies.find(obj => obj.insuranceId === parseInt(insuranceId));
            setPolicy(policy);
        }
    },[myPolicies, insuranceId])

    const returnToPayment = async () => {
        await dispatch(actionsPolicy.restorePolicyDataAfterPayAtempt(policy, cashflowId));
        await dispatch(actionsPolicy.setStepLiability(15));    

        history.push('/app/new-policy-liability');
    }

    const closeModal = () => {
        setLoading(true);
        returnToPayment();
        setShowNoSuccess(false);
    }

    const renderInfoTexts = () => {
        if(status === 'ERROR') return null;

        return infoTexts.filter(text => text).map((text, i) => {
                return <div className="steps_container-info" key={i+1}>
                            <div>
                                <InfoIcon size="20" style={{marginLeft: '2px'}}/>
                            </div>
                            <div>{text}</div>
                        </div>
        })
    }

    return (
        <div className="steps_container" >
            <div  className="head">
                <h6 className="title" style={{marginRight: '48px'}}>{setInstallmentText(cashflow)}</h6>
            </div>
            <Divider style={{marginBottom: 0 , backgroundColor: '#6bdfa7', height: '.5px'}}/>
            <div className="payment-card">
                <div className="left">
                    <p style={{marginBottom: '8px'}}>{vechicleMake}</p>
                    <p style={{}}>{vechiclePlate}</p>
                </div>
                <div className="right">
                <p style={{marginBottom: '8px', opacity: '.7'}}>{status === 'ERROR' ? 'Сума' : 'Платена сума'}</p>
                <p style={{fontWeight: '700', fontSize: '15px', paddingLeft: '8px'}}>{payAmountEUR} € / {payAmount} лв.</p>
                </div>
            </div>
            <div className="big-icon-container" style={{margin: '20px 0'}}>
                <FrameTwoIcon size={120}/>
            </div>
            {renderInfoTexts()}
    
            <Link to="/app/my-policies" className="nuIns-btn nuIns-btn-main" style={{margin: '36px 0'}}>Моите полици</Link>

            {loading ? <Loader backdrop center size="lg" speed="slow" /> : null}

            {/* Modal for unsuccesfull payment */}
            <Modal size="xs" show={showNoSuccess} className="nuins-ok-modal" onHide={() => closeModal()}>
                <Modal.Body >
                    <p className="no-reg-data">Плащането не беше успешно, моля опитайте по късно </p>    
                </Modal.Body>
                <Modal.Footer >
                    <Button onClick={() => closeModal()} >OK</Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default PaymentFinishedNC;